/* * 对比分析 * @module components/leftmenu/contrast * @desc 用于展示对比 * @author sunsi * @date
2020年8月13日 */
<template>
  <div>
    <Row
      style="text-align: center;width:100%;
height:120px;
border-bottom:1px solid rgba(237,237,237,1);"
      justify="center"
    >
      <div class="default sx" style="display: inline-block;" v-on:click.stop="comparative(0)">
        <div class="imgBox1">
          <img src="../../../../static/image/contrast/sp2.png" />
        </div>
        <p class="text">双屏对比</p>
      </div>

      <div class="default qy" style="display: inline-block;" v-on:click.stop="comparative(1)">
        <div class="imgBox1">
          <img src="../../../../static/image/contrast/dp2.png" />
        </div>
        <p class="text">多屏对比</p>
      </div>

      <div class="default fh" style="display: inline-block;" v-on:click.stop="comparative(2)">
        <div class="imgBox1">
          <img src="../../../../static/image/contrast/jl2.png" />
        </div>
        <p class="text">卷帘模式</p>
      </div>
    </Row>
  </div>
</template>
<script>
import contrast from './contrast';
export default contrast;
</script>
<style lang="less" scoped>
.default {
  display: inline-block;
  width: 72.072px;
  height: 72.072px;
  vertical-align: middle;
  margin-right: 10px;
  background-repeat: no-repeat;
  margin-top: 19px;
  cursor: pointer;
}
.imgBox1 {
  padding-top: 15px;
}
.sx {
  background-image: url('../../../../static/image/contrast/sp1.png');
}
.qy {
  background-image: url('../../../../static/image/contrast/dp1.png');
}
.fh {
  background-image: url('../../../../static/image/contrast/jl1.png');
}
.sx:hover {
  background-image: url('../../../../static/image/contrast/sp11.png');
}
.qy:hover {
  background-image: url('../../../../static/image/contrast/dp11.png');
}
.fh:hover {
  background-image: url('../../../../static/image/contrast/jl11.png');
}
.text {
  font-size: 10px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/contrast/contrast.vue